var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-4 -4 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dns6e9pxva"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1368 0v4600H0V0h1368z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6b3jtxha3b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19 5.714c1.28 0 2.325 1.01 2.38 2.278l.001.103v.953a.476.476 0 0 1-.949.055l-.003-.055v-.953c0-.76-.595-1.382-1.345-1.426l-.084-.002H2.381c-.76 0-1.383.594-1.426 1.344l-.003.084v.953a.476.476 0 0 1-.949.055L0 9.048v-.953c0-1.28 1.01-2.324 2.278-2.379l.103-.002h3.81zM4.286 0a2.381 2.381 0 1 1 0 4.762 2.381 2.381 0 0 1 0-4.762zm0 .952a1.429 1.429 0 1 0 0 2.858 1.429 1.429 0 0 0 0-2.858z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dns6e9pxva)",
    transform: "translate(-531 -1699)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6b3jtxha3b)",
    transform: "translate(532.714 1700.238)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(210, 210, 210, 0.88)",
    d: "M0 0h8.571v9.524H0V0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUser);
export default __webpack_public_path__ + "static/media/icons-user.3614cfc56f7b3dc7afe68eb879ed37fc.svg";
export { ForwardRef as ReactComponent };